module.exports = __webpack_public_path__ + "img/story7.dc752bc8.png";